import { Controller } from "@hotwired/stimulus"

const REDUCED = "(prefers-reduced-motion: reduce)"

/**
 * The publish beat: the draft card settles into the published story.
 *
 * Both cards share one grid cell (see .lp-swap), so the container is always as
 * tall as the taller of the two and the swap can't crop or jolt the page.
 * Replays when the section is scrolled back into view.
 */
export default class extends Controller {
  static targets = ["swap", "state"]

  static values = { delay: { type: Number, default: 700 } }

  connect() {
    if (window.matchMedia(REDUCED).matches) return

    this.timers = []

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.play()
        } else {
          this.reset()
        }
      },
      // A section taller than the viewport can never reach a fractional
      // threshold, so trigger on overlap with the middle band instead.
      { threshold: 0, rootMargin: "-20% 0px -20% 0px" }
    )

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    this.clearTimers()
  }

  play() {
    if (this.playing) return
    this.playing = true

    this.after(this.delayValue, () => {
      if (this.hasSwapTarget) this.swapTarget.classList.add("is-published")
      if (this.hasStateTarget) this.stateTarget.textContent = "published"
    })
  }

  reset() {
    this.clearTimers()
    this.playing = false
    if (this.hasSwapTarget) this.swapTarget.classList.remove("is-published")
    if (this.hasStateTarget) this.stateTarget.textContent = "draft"
  }

  after(ms, fn) {
    this.timers.push(setTimeout(fn, ms))
  }

  clearTimers() {
    ;(this.timers || []).forEach(clearTimeout)
    this.timers = []
  }
}
